class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[name="q"]');
    this.clear = this.querySelector("[data-clear]");
    this.submit = this.querySelector('[type="submit"]');

    this.input.addEventListener("input", (e) => this._toggleDirty());

    this.clear.addEventListener("click", () => {
      this._clear();
      this.input.focus();
    });

    this.addEventListener("search-form:clear", () => this._clear());
    this.addEventListener("search-form:focus", () => this.input.focus());

    this.handleMenuClose = () => {
      this.input.value = "";
    };
  }

  _clear() {
    this.input.value = "";
    this._toggleDirty();
  }

  _toggleDirty() {
    this.toggleAttribute("dirty", this.input.value.length);
    if (this.submit) {
      this.submit.disabled = !this.input.value.length;
    }
  }
}

if (!customElements.get("search-form")) {
  customElements.define("search-form", SearchForm);
}
